import React from 'react';
import Header from '../../organisms/header';
import Body from '../../organisms/body/Body';
import './styles.scss';

function Home() {
  return (
    <>
      <Header />
      <Body />
    </>
  );
}

export default Home;
